import { Injectable } from '@angular/core';
import { CookieAdapterService } from '../core/cookie-adapter.service';

const TOKEN_COOKIE_KEY = 'OESSOTOK';
const TOKEN_SEPARATOR = '.';
const THIRD_PARTY_TOKEN_TYPE_KEY = 'THIRD_PARTY_TOKEN_TYPE';
enum ThirdPartyTokenTypes {
    OE_SFDC = 'OE_SFDC'
}
enum TokenAnatomy {
    HEADER,
    DATA,
    SIGNATURE
}

@Injectable()
export class TokenService {
    constructor(private readonly cookieService: CookieAdapterService) {}

    public get decodedToken() {
        return this.token
            .split(TOKEN_SEPARATOR)
            .map((fragment, index) => {
                if (index === TokenAnatomy.SIGNATURE) {
                    return fragment;
                }
                return JSON.parse(atob(fragment));
            });
    }

    public get token() {
        return this.cookieService.get(TOKEN_COOKIE_KEY);
    }

    public get hasToken() {
        return !!this.token;
    }

    public get tokenHeader() {
        return this.decodedToken[TokenAnatomy.HEADER];
    }

    public get tokenData() {
        return this.decodedToken[TokenAnatomy.DATA];
    }

    public get tokenSignature() {
        return this.decodedToken[TokenAnatomy.SIGNATURE];
    }

    public get isLoggedAs() {
        return this.tokenData[THIRD_PARTY_TOKEN_TYPE_KEY] === ThirdPartyTokenTypes.OE_SFDC;
    }
}


// WEBPACK FOOTER //
// ./ts/app/shared/token.service.ts